//Node Modules
import { domToReact } from 'html-react-parser'

export default (node:any, params:any, options:any) => {
  // Remove any child elements that are just whitespace
  const children = node.children.filter((child:any) => child.type !== 'text' || child.data.match(/\s*/) === null)

  // Set new list of children on node
  node.children = children

  return domToReact(node, options)
}